import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineStore } from 'pinia';
import { floor } from 'lodash-es';
import Cookies from 'js-cookie';
import { generateQuestions } from '~/core/components/Questionnaire/functions/generateQuestions';
import { QuestionGroup } from '~/core/components/Questionnaire/enums';
import { DentalAndSurgicalCommonQuestionId, DentalQuestionId, GynecologicalQuestionId, SexualPartnerValue, SurgicalQuestionId, TherapeuticQuestionId } from '~/core/components/Questionnaire/enums';
import { DENTAL_QUESTION_ORDERED_QUESTIONS_IDS, GYNECOLOGICAL_ORDERED_QUESTIONS_IDS, SURGICAL_ORDERED_QUESTIONS_IDS, THERAPEUTIC_ORDERED_QUESTIONS_IDS } from '~/core/components/Questionnaire/constants';
import { QuestionnaireApi } from '~/core/api';
import { getDecryptedQuestionnaire } from '~/core/components/Questionnaire/functions';
import { CookieKey, HttpStatusCode } from '~/core/enums';
import { Gender } from '~/features/Profile/enums';
export default defineStore('questionnaire', function () {
  var _useNuxtApp = useNuxtApp(),
    $captureException = _useNuxtApp.$captureException;
  var isLoading = ref(false);
  var questions = ref(generateQuestions());
  var appointmentsQuestionGroups = ref([]);
  var isChangesApplied = ref(false);
  var isFillingState = ref(false);
  var isEmpty = computed(function () {
    return !questions.value.some(function (_ref) {
      var answer = _ref.answer;
      return Boolean(answer);
    });
  });
  function getQuestionById(id) {
    var _questions$value$find;
    return (_questions$value$find = questions.value.find(function (_ref2) {
      var questionId = _ref2.questionId;
      return questionId === id;
    })) !== null && _questions$value$find !== void 0 ? _questions$value$find : null;
  }
  var availableQuestionGroups = computed(function () {
    var firstTherapeuticQuestion = getQuestionById(THERAPEUTIC_ORDERED_QUESTIONS_IDS[0]);
    var firstGynecologicalQuestion = getQuestionById(GYNECOLOGICAL_ORDERED_QUESTIONS_IDS[0]);
    var firstDentalQuestion = getQuestionById(DENTAL_QUESTION_ORDERED_QUESTIONS_IDS[0]);
    var firstSurgicalQuestion = getQuestionById(SURGICAL_ORDERED_QUESTIONS_IDS[0]);
    var implantsQuestion = getQuestionById(DentalAndSurgicalCommonQuestionId.Implants);
    var res = [];
    var isGroupAvailable = function isGroupAvailable(group) {
      return appointmentsQuestionGroups.value.includes(group);
    };
    if (firstTherapeuticQuestion !== null && firstTherapeuticQuestion !== void 0 && firstTherapeuticQuestion.completed || isGroupAvailable(QuestionGroup.Therapy)) {
      res.push(QuestionGroup.Therapy);
    }
    if (firstGynecologicalQuestion !== null && firstGynecologicalQuestion !== void 0 && firstGynecologicalQuestion.completed || isGroupAvailable(QuestionGroup.Gynecology)) {
      res.push(QuestionGroup.Gynecology);
    }
    if (firstDentalQuestion !== null && firstDentalQuestion !== void 0 && firstDentalQuestion.completed || isGroupAvailable(QuestionGroup.Dentistry)) {
      res.push(QuestionGroup.Dentistry);
    }
    if (firstSurgicalQuestion !== null && firstSurgicalQuestion !== void 0 && firstSurgicalQuestion.completed || isGroupAvailable(QuestionGroup.Surgery)) {
      res.push(QuestionGroup.Surgery);
    }
    if (implantsQuestion !== null && implantsQuestion !== void 0 && implantsQuestion.completed && !res.includes(QuestionGroup.Surgery) && !res.includes(QuestionGroup.Dentistry)) {
      res.push(QuestionGroup.Surgery);
      res.push(QuestionGroup.Dentistry);
    }
    return res;
  });
  var composedQuestions = computed(function () {
    var profileAnswer = questions.value[0].answer;
    var isGroupAvailable = function isGroupAvailable(group) {
      return availableQuestionGroups.value.includes(group);
    };
    var skippedQuestions = [];
    if (!isGroupAvailable(QuestionGroup.Dentistry) && !isGroupAvailable(QuestionGroup.Surgery)) {
      skippedQuestions = [].concat(_toConsumableArray(skippedQuestions), [DentalAndSurgicalCommonQuestionId.Implants]);
    }
    if (!isGroupAvailable(QuestionGroup.Therapy)) {
      skippedQuestions = [].concat(_toConsumableArray(skippedQuestions), _toConsumableArray(Object.values(TherapeuticQuestionId)));
    }
    if (!isGroupAvailable(QuestionGroup.Gynecology)) {
      skippedQuestions = [].concat(_toConsumableArray(skippedQuestions), _toConsumableArray(Object.values(GynecologicalQuestionId)));
    }
    if (!isGroupAvailable(QuestionGroup.Surgery)) {
      skippedQuestions = [].concat(_toConsumableArray(skippedQuestions), _toConsumableArray(Object.values(SurgicalQuestionId)));
    }
    if (!isGroupAvailable(QuestionGroup.Dentistry)) {
      skippedQuestions = [].concat(_toConsumableArray(skippedQuestions), _toConsumableArray(Object.values(DentalQuestionId)));
    }
    if ((profileAnswer === null || profileAnswer === void 0 ? void 0 : profileAnswer.gender) === Gender.Male) {
      skippedQuestions = [].concat(_toConsumableArray(skippedQuestions), [TherapeuticQuestionId.Pregnancy], _toConsumableArray(isGroupAvailable(QuestionGroup.Gynecology) ? Object.values(GynecologicalQuestionId) : []));
    } else if ((profileAnswer === null || profileAnswer === void 0 ? void 0 : profileAnswer.gender) === Gender.Female && isGroupAvailable(QuestionGroup.Gynecology)) {
      var _firstMenstruation$an, _pregnancyCount$answe, _pregnancyBirthCount$, _sexualContacts$answe;
      var firstMenstruation = questions.value.find(function (_ref3) {
        var questionId = _ref3.questionId;
        return questionId === GynecologicalQuestionId.FirstMenstruation;
      });
      var pregnancyCount = questions.value.find(function (_ref4) {
        var questionId = _ref4.questionId;
        return questionId === GynecologicalQuestionId.PregnanciesNumber;
      });
      var pregnancyBirthCount = questions.value.find(function (_ref5) {
        var questionId = _ref5.questionId;
        return questionId === GynecologicalQuestionId.PregnanciesWithBirth;
      });
      var sexualContacts = questions.value.find(function (_ref6) {
        var questionId = _ref6.questionId;
        return questionId === GynecologicalQuestionId.SexualPartner;
      });
      if (firstMenstruation.completed && ((_firstMenstruation$an = firstMenstruation.answer) === null || _firstMenstruation$an === void 0 ? void 0 : _firstMenstruation$an.age) === null) {
        skippedQuestions = [].concat(_toConsumableArray(skippedQuestions), [GynecologicalQuestionId.LastMenstruation, GynecologicalQuestionId.PregnanciesNumber, GynecologicalQuestionId.PregnanciesWithBirth, GynecologicalQuestionId.Childbirth]);
      } else if (pregnancyCount.completed && [0, null].includes((_pregnancyCount$answe = pregnancyCount.answer) === null || _pregnancyCount$answe === void 0 ? void 0 : _pregnancyCount$answe.number)) {
        skippedQuestions = [].concat(_toConsumableArray(skippedQuestions), [GynecologicalQuestionId.PregnanciesWithBirth, GynecologicalQuestionId.Childbirth]);
      } else if (pregnancyBirthCount.completed && [0, null].includes((_pregnancyBirthCount$ = pregnancyBirthCount.answer) === null || _pregnancyBirthCount$ === void 0 ? void 0 : _pregnancyBirthCount$.number)) {
        skippedQuestions = [].concat(_toConsumableArray(skippedQuestions), [GynecologicalQuestionId.Childbirth]);
      }
      if (sexualContacts.completed && ((_sexualContacts$answe = sexualContacts.answer) === null || _sexualContacts$answe === void 0 ? void 0 : _sexualContacts$answe.constantPartner) === SexualPartnerValue.NoContacts) {
        skippedQuestions = [].concat(_toConsumableArray(skippedQuestions), [GynecologicalQuestionId.ContraceptionMethod]);
      }
    }
    return questions.value.filter(function (_ref7) {
      var questionId = _ref7.questionId;
      return !skippedQuestions.includes(questionId);
    });
  });
  var completionPercentage = computed(function () {
    var questions = composedQuestions.value;
    if (!questions.length) {
      return 0;
    }
    return floor(questions.reduce(function (acc, _ref8) {
      var completed = _ref8.completed;
      return completed ? ++acc : acc;
    }, 0) / questions.length * 100);
  });
  function setQuestion(question) {
    var target = questions.value.find(function (_ref9) {
      var questionId = _ref9.questionId;
      return questionId === question.questionId;
    });
    if (target) {
      var _question$completed;
      target.answer = question.answer;
      target.completed = (_question$completed = question.completed) !== null && _question$completed !== void 0 ? _question$completed : false;
    }
  }
  function fetchQuestionnaire() {
    return _fetchQuestionnaire.apply(this, arguments);
  }
  function _fetchQuestionnaire() {
    _fetchQuestionnaire = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$QuestionnaireA, data, res, _response, acceptableStatuses;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            isLoading.value = true;
            _context.prev = 1;
            _context.next = 4;
            return QuestionnaireApi.getQuestionGroups();
          case 4:
            _yield$QuestionnaireA = _context.sent;
            data = _yield$QuestionnaireA.data;
            appointmentsQuestionGroups.value = data.questionGroups;
            isChangesApplied.value = false;
            _context.next = 10;
            return getDecryptedQuestionnaire();
          case 10:
            res = _context.sent;
            questions.value = questions.value.map(function (item) {
              var _target$answer;
              var target = res.find(function (_ref10) {
                var questionId = _ref10.questionId;
                return questionId === item.questionId;
              });
              return _objectSpread(_objectSpread({}, item), {}, {
                answer: (_target$answer = target === null || target === void 0 ? void 0 : target.answer) !== null && _target$answer !== void 0 ? _target$answer : null,
                completed: Boolean(target === null || target === void 0 ? void 0 : target.answer)
              });
            });
            _context.next = 22;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);
            questions.value = generateQuestions();
            acceptableStatuses = [HttpStatusCode.NotFound, HttpStatusCode.Forbidden];
            if (!acceptableStatuses.includes((_response = _context.t0.response) === null || _response === void 0 ? void 0 : _response.status)) {
              _context.next = 20;
              break;
            }
            return _context.abrupt("return");
          case 20:
            $captureException(_context.t0, {
              method: 'fetchQuestionnaire',
              message: 'medcard-questionnaire',
              component: 'useQuestionnaireStore'
            });
            throw _context.t0;
          case 22:
            _context.prev = 22;
            isLoading.value = false;
            return _context.finish(22);
          case 25:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 14, 22, 25]]);
    }));
    return _fetchQuestionnaire.apply(this, arguments);
  }
  function saveQuestion(_x) {
    return _saveQuestion.apply(this, arguments);
  }
  function _saveQuestion() {
    _saveQuestion = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(answer) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return QuestionnaireApi.sendAnswer(_objectSpread(_objectSpread({}, answer), {}, {
              patientAnonymousToken: Cookies.get(CookieKey.AnonymousQuestionnaireUid) || undefined
            }));
          case 2:
            setQuestion(_objectSpread(_objectSpread({}, answer), {}, {
              completed: true
            }));
            isChangesApplied.value = true;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _saveQuestion.apply(this, arguments);
  }
  function deleteQuestionnaire() {
    return _deleteQuestionnaire.apply(this, arguments);
  }
  function _deleteQuestionnaire() {
    _deleteQuestionnaire = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            isLoading.value = true;
            isChangesApplied.value = false;
            _context3.prev = 2;
            _context3.next = 5;
            return QuestionnaireApi.deleteQuestionnaire();
          case 5:
            _context3.next = 11;
            break;
          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](2);
            $captureException(_context3.t0, {
              method: 'deleteQuestionnaire',
              message: 'medcard-questionnaire',
              component: 'useQuestionnaireStore'
            });
            throw _context3.t0;
          case 11:
            _context3.prev = 11;
            isLoading.value = false;
            questions.value = generateQuestions();
            return _context3.finish(11);
          case 15:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 7, 11, 15]]);
    }));
    return _deleteQuestionnaire.apply(this, arguments);
  }
  function clearQuestionnaire() {
    isChangesApplied.value = false;
    questions.value = generateQuestions();
    appointmentsQuestionGroups.value = [];
    isFillingState.value = false;
    isLoading.value = false;
  }
  return {
    isLoading: isLoading,
    questions: questions,
    appointmentsQuestionGroups: appointmentsQuestionGroups,
    isChangesApplied: isChangesApplied,
    isFillingState: isFillingState,
    isEmpty: isEmpty,
    availableQuestionGroups: availableQuestionGroups,
    composedQuestions: composedQuestions,
    completionPercentage: completionPercentage,
    getQuestionById: getQuestionById,
    setQuestion: setQuestion,
    fetchQuestionnaire: fetchQuestionnaire,
    saveQuestion: saveQuestion,
    deleteQuestionnaire: deleteQuestionnaire,
    clearQuestionnaire: clearQuestionnaire
  };
});